import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { DEPLOYMENTS } from '../deployment.mock';

@Injectable()
export class DeploymentEntityServiceMock {
  entities$ = of(DEPLOYMENTS);

  getByAnimalId() {
    return of(DEPLOYMENTS);
  }

  getByCollarId() {
    return of(DEPLOYMENTS);
  }

  getAll() {
    return of(DEPLOYMENTS);
  }

  findCurrentDeploymentByCollarId() {
    return of(DEPLOYMENTS[0]);
  }
}
